import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { createDataCollection as universalCreateDataCollection, deleteDataCollection as universalDeleteDataCollection, getDataCollection as universalGetDataCollection, listDataCollections as universalListDataCollections, updateDataCollection as universalUpdateDataCollection, } from './data-v2-data-collection-collections.universal';
export const __metadata = { PACKAGE_NAME: '@wix/data' };
export function createDataCollection(httpClient) {
    return (collection) => universalCreateDataCollection(collection, 
    // @ts-ignore
    { httpClient });
}
export function getDataCollection(httpClient) {
    return (dataCollectionId, options) => universalGetDataCollection(dataCollectionId, options, 
    // @ts-ignore
    { httpClient });
}
export function listDataCollections(httpClient) {
    return (options) => universalListDataCollections(options, 
    // @ts-ignore
    { httpClient });
}
export function updateDataCollection(httpClient) {
    return (collection) => universalUpdateDataCollection(collection, 
    // @ts-ignore
    { httpClient });
}
export function deleteDataCollection(httpClient) {
    return (dataCollectionId) => universalDeleteDataCollection(dataCollectionId, 
    // @ts-ignore
    { httpClient });
}
export const onDataCollectionClonedEvent = EventDefinition('wix.data.v2.data_collection_data_collection_cloned_event', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [{ path: 'metadata.eventTime' }],
    },
])))();
export const onDataCollectionChangedEvent = EventDefinition('wix.data.v2.data_collection_data_collection_changed_event', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [
            { path: 'data.fieldsAdded.numberRange.min' },
            { path: 'data.fieldsAdded.numberRange.max' },
            { path: 'data.fieldsUpdated.previous.numberRange.min' },
            { path: 'data.fieldsUpdated.previous.numberRange.max' },
            { path: 'data.fieldsUpdated.current.numberRange.min' },
            { path: 'data.fieldsUpdated.current.numberRange.max' },
            { path: 'data.fieldsRemoved.numberRange.min' },
            { path: 'data.fieldsRemoved.numberRange.max' },
        ],
    },
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [{ path: 'metadata.eventTime' }],
    },
])))();
export const onDataCollectionCreated = EventDefinition('wix.data.v2.data_collection_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [
            { path: 'entity.fields.numberRange.min' },
            { path: 'entity.fields.numberRange.max' },
        ],
    },
])))();
export const onDataCollectionUpdated = EventDefinition('wix.data.v2.data_collection_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [
            { path: 'entity.fields.numberRange.min' },
            { path: 'entity.fields.numberRange.max' },
        ],
    },
])))();
export const onDataCollectionDeleted = EventDefinition('wix.data.v2.data_collection_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'undefined.createdDate' },
            { path: 'undefined.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [
            { path: 'undefined.fields.numberRange.min' },
            { path: 'undefined.fields.numberRange.max' },
        ],
    },
])))();
export { AccessLevel, CollectionOperation, CollectionType, DataOperation, Direction, FieldPluginType, Format, IndexStatus, Order, PagingMode, PluginType, QueryOperator, Role, SortOrder, Status, Type, WebhookIdentityType, } from './data-v2-data-collection-collections.universal';
//# sourceMappingURL=data-v2-data-collection-collections.public.js.map